import { render } from "./Label.vue?vue&type=template&id=812c3520"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "812c3520"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('812c3520', script)) {
    api.reload('812c3520', script)
  }
  
  module.hot.accept("./Label.vue?vue&type=template&id=812c3520", () => {
    api.rerender('812c3520', render)
  })

}

script.__file = "resources/js/Jetstream/Label.vue"

export default script